import styled from '@emotion/styled';

export const SadaKTimestamp = styled.div``;
